import { Outlet } from "react-router-dom";

export default function FinancePage() {
  return (
    <div>
      <Outlet />
    </div>
  );
}
